const waitUntilVisibleClassName = 'waitUntilVisible';
const isVisibleClassName = 'isVisible';

export function waitUntilVisible(): void {
  if (typeof window === 'undefined') return;
  const elements = document.querySelectorAll<HTMLElement>(`.${waitUntilVisibleClassName}`);
  if (!elements.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach((el) => el.classList.add(isVisibleClassName));
    return;
  }
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(isVisibleClassName);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25 }
  );
  elements.forEach((el) => observer.observe(el));
}
